import React from "react";
import Bank1 from "../assets/Bank1.png.jpeg";
import hotel1 from "../assets/hotel1.png.jpeg";
import hotel2 from "../assets/Bank2.png.jpeg";
import bus2 from "../assets/bus2.png.jpeg";
import bus4 from "../assets/bus4.png.jpeg";
import Bank3 from "../assets/Bank3.png.jpeg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./Home.css";
import { useNavigate, Link } from "react-router-dom";

export default function Home() {
  const images = [Bank1, hotel1, hotel2, bus2, bus4, Bank3];

  return (
    <div className="flex h-screen mt-5">
      
      <div className="carousel-container w-full ml-0">
        <Carousel showThumbs={false} autoPlay infiniteLoop>
          {images.map((image, index) => (
            <div key={index} className="carousel-slide">
              <img
                src={image}
                alt={`Slide ${index}`}
                className="object-cover "
              />
              <div className="carousel-text flex flex-col max-w-full min-w-fit text-center flex-wrap">
                <h4>Virtual Business</h4>
                <h1 className="text-blue-500 italic font-bold">Welcome to Virtual Business</h1>
                <p>Experience seamless and convenient business
                  <br/>
                   solutions  just at the palm of your hands</p>   
                      
               <p>With enhanced technology and seamless business 
               <br/>
                transformation with enhanced security </p>
               <p>Create your own business with enhanced user 
               <br/>
                Experience and developed technology</p>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}

